import { Injectable } from '@angular/core';

@Injectable()
export class DataService { 
    alertId:any;
    mediaUrl:string;
    constructor(){}
}